export const addHourTo24hrString = (time: string) => {
  const [hours, minutes] = time.split(':')
  const updatedHours = (hours === '23' ? '00' : parseInt(hours, 10) + 1).toString().padStart(2, '0')
  return `${updatedHours}:${minutes}`
}
